import HeaderGeral from "../components/HeaderGeral";
import Forms from "../components/Forms";
import css from "./Contatos.module.css"
import Footer from "../components/Footer";
import CarrosselEstrutura from "../components/CarrosselEstrutura";
import Mapa from "../components/Mapa";
import MeiosContatos from "../components/MeiosContatos";
import HeaderHome from "../components/HeaderHome";


function Contatos(){
    return (
        <div className={`${css.contatos} d-flex flex-column justify-content-center align-items-center`}>
            <HeaderHome></HeaderHome>
            <h1 className={css.fale}>Fale Conosco</h1>
            <Forms></Forms>
            <div className={`${css.estrutura} d-flex flex-column justify-content-center align-items-center my-5 px-lg-30 px-5`}>
                <p className={`${css.estruturatitulo}`}> Conheça a estrutura da clínica: </p>
                <p className={`${css.estruturadesc}`}>A Clínica NeuroAudio é especializada no cuidado da audição, do labirinto e da comunicação; com uma abordagem que integra audiologia e neurociência. Nosso compromisso é oferecer avaliações precisas e tratamentos personalizados, respeitando as necessidades individuais de cada paciente em todas as fases da vida.

                    Atuamos com tecnologia moderna, métodos baseados em evidências científicas e uma equipe qualificada, que prioriza o atendimento humanizado, ético e responsável. Cada paciente é acolhido de forma única, com atenção à sua história, às suas queixas e aos seus objetivos.

                    Na NeuroAudio, entendemos que ouvir bem e ter um bom equilíbrio é essencial para o desenvolvimento, a interação social, a aprendizagem e a qualidade de vida. Por isso, trabalhamos para promover não apenas a melhora auditiva, mas também o bem-estar e a autonomia de nossos pacientes.
                </p>
            </div>
            <CarrosselEstrutura/>
            <Mapa/>
            <Footer></Footer>
        </div>
    )
}

export default Contatos;